// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.user-info {\r\n  font-size: 12px;\r\n  line-height: 11px;\n}\n.label {\r\n  font-size: 10px;\r\n  font-weight: bold;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
